import {useEffect,useState} from 'react';
import { ToastContainer, Zoom,toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ErrorPopUp = (msg) => {
    
        toast.error(msg, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
            className: "errorToast",
            hideProgressBar: true,
        })
    
}

export default ErrorPopUp